import { useEntities } from '../useEntities';

export function useEntity(entityNumber: string) {
  const { entityByNumber, isLoading, error } = useEntities();

  return { entity: entityByNumber[entityNumber], isLoading, error };
}
